import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators"; 
import { environment } from "../../../../environments/environment";
import { Info } from "../../../modals/info.model"; 

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(private http: HttpClient) {}

  public getInfo(): Observable<Info> {
    return this.http.get<Info>(environment.baseUrl + 'Klijenti/GetInfo').pipe(
      map((response: any) => ({
        naziv: response.naziv,
        adresa: response.adresa,
        telefon: response.telefon,
        mjesto: response.mjesto,
        email: response.email,
        opis: response.opis || null
      }))
    );
  }
}